import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/Button';
import { Youtube, Facebook, Radio, Smartphone, Monitor, Play, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
export function LiveStreamPage() {
  return <Layout data-id="element-798">
      {/* Header */}
      <div className="bg-[#0A1F44] pt-44 md:pt-48 pb-20 text-center text-white relative overflow-hidden" data-id="element-799">
        <div className="absolute inset-0 opacity-20" data-id="element-800">
          <img src="https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" alt="Background" className="w-full h-full object-cover" data-id="element-801" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44] via-[#0A1F44]/70 to-[#0A1F44]" data-id="element-802" />
        <div className="container-custom relative z-10" data-id="element-803">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-1.5 rounded-full text-sm font-medium mb-6" data-id="element-804">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse" data-id="element-805" />
            Live Every Sunday
          </div>
          <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4" data-id="element-806">
            Live Stream
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-807">
            Join us online for worship, wherever you are.
          </p>
        </div>
      </div>

      {/* Main Stream Section */}
      <section className="py-12 md:py-20 bg-white" data-id="element-808">
        <div className="container-custom" data-id="element-809">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-810">
            {/* Video Player */}
            <div className="lg:col-span-2" data-id="element-811">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} className="bg-black rounded-2xl overflow-hidden shadow-2xl aspect-video relative" data-id="element-812">
                {/* Placeholder for actual video player */}
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-8 text-center" data-id="element-813">
                  <Youtube className="w-16 h-16 text-red-600 mb-4" data-id="element-814" />
                  <h3 className="text-2xl font-bold mb-2" data-id="element-815">
                    Sunday Service Broadcast
                  </h3>
                  <p className="text-gray-400 mb-6" data-id="element-816">
                    Our next live stream begins Sunday at 10:00 AM EST
                  </p>
                  <Button variant="primary" leftIcon={<Play className="w-4 h-4" data-id="element-818" />} data-id="element-817">
                    Watch Latest Sermon
                  </Button>
                </div>
              </motion.div>

              {/* Stream Info */}
              <div className="mt-8 bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-819">
                <h3 className="text-xl font-bold text-[#0A1F44] mb-2" data-id="element-820">
                  Experiencing issues?
                </h3>
                <p className="text-gray-600 text-sm mb-4" data-id="element-821">
                  If the video player above isn't working, you can also watch
                  our live stream directly on our social media platforms.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-822">
                  <a href="https://youtube.com/@householdchurch" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-medium text-red-600 hover:text-red-700 transition-colors" data-id="element-823">
                    <Youtube className="w-4 h-4" data-id="element-824" /> Watch on YouTube
                    <ExternalLink className="w-3 h-3" data-id="element-825" />
                  </a>
                  <a href="https://facebook.com/householdchurch" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors" data-id="element-826">
                    <Facebook className="w-4 h-4" data-id="element-827" /> Watch on Facebook
                    <ExternalLink className="w-3 h-3" data-id="element-828" />
                  </a>
                </div>
              </div>
            </div>

            {/* Ways to Watch */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="flex flex-col justify-center" data-id="element-829">
              <span className="text-[#C8102E] text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-830">
                Other Platforms
              </span>
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0A1F44] mb-6" data-id="element-831">
                Watch & Listen
                <br data-id="element-832" />
                <span className="text-[#0A1F44]" data-id="element-833">On The Way</span>
              </h2>
              <p className="text-gray-600 mb-8 text-lg leading-relaxed" data-id="element-834">
                Stay connected and join our online services via Facebook and
                YouTube. Never miss a powerful message - watch live or catch up
                on past sermons anytime, anywhere.
              </p>

              {/* Stream Buttons */}
              <div className="flex flex-wrap gap-4" data-id="element-835">
                <a href="https://youtube.com/@householdchurch" target="_blank" rel="noopener noreferrer" data-id="element-836">
                  <Button variant="secondary" size="lg" className="bg-[#0A1F44] hover:bg-[#081833]" leftIcon={<Youtube className="w-5 h-5" data-id="element-838" />} data-id="element-837">
                    YouTube
                  </Button>
                </a>
                <a href="https://facebook.com/householdchurch" target="_blank" rel="noopener noreferrer" data-id="element-839">
                  <Button variant="outline" size="lg" className="border-[#1877F2] text-[#1877F2] hover:bg-[#1877F2] hover:text-white" leftIcon={<Facebook className="w-5 h-5" data-id="element-841" />} data-id="element-840">
                    Facebook
                  </Button>
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Service Times Reminder */}
      <section className="py-16 bg-[#0A1F44]" data-id="element-842">
        <div className="container-custom" data-id="element-843">
          <div className="max-w-3xl mx-auto text-center" data-id="element-844">
            <Radio className="w-10 h-10 text-[#C8102E] mx-auto mb-6" data-id="element-845" />
            <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-846">
              When to Tune In
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-847">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl" data-id="element-848">
                <h4 className="font-bold text-white mb-2" data-id="element-849">Sunday Service</h4>
                <p className="text-white/80" data-id="element-850">10:00 AM EST</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl" data-id="element-851">
                <h4 className="font-bold text-white mb-2" data-id="element-852">Impact Wednesday</h4>
                <p className="text-white/80" data-id="element-853">7:00 PM EST</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl" data-id="element-854">
                <h4 className="font-bold text-white mb-2" data-id="element-855">Deep Dive</h4>
                <p className="text-white/80" data-id="element-856">Sunday 9:00 AM EST</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Devices Section */}
      <section className="py-20 bg-gray-50" data-id="element-857">
        <div className="container-custom" data-id="element-858">
          <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-859">
            <h2 className="text-3xl font-serif font-bold text-[#0A1F44] mb-4" data-id="element-860">
              Watch on Any Device
            </h2>
            <p className="text-gray-600" data-id="element-861">
              Our stream is optimized for all your devices so you can worship
              wherever you are.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-862">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white p-8 rounded-xl shadow-sm text-center" data-id="element-863">
              <Monitor className="w-12 h-12 text-[#C8102E] mx-auto mb-4" data-id="element-864" />
              <h3 className="font-bold text-[#0A1F44] mb-2" data-id="element-865">Desktop & TV</h3>
              <p className="text-sm text-gray-600" data-id="element-866">
                Watch in full HD on your computer or cast to your smart TV.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white p-8 rounded-xl shadow-sm text-center" data-id="element-867">
              <Smartphone className="w-12 h-12 text-[#C8102E] mx-auto mb-4" data-id="element-868" />
              <h3 className="font-bold text-[#0A1F44] mb-2" data-id="element-869">Mobile & Tablet</h3>
              <p className="text-sm text-gray-600" data-id="element-870">
                Perfect for watching on the go with our mobile-optimized stream.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white p-8 rounded-xl shadow-sm text-center" data-id="element-871">
              <Radio className="w-12 h-12 text-[#C8102E] mx-auto mb-4" data-id="element-872" />
              <h3 className="font-bold text-[#0A1F44] mb-2" data-id="element-873">Audio Only</h3>
              <p className="text-sm text-gray-600" data-id="element-874">
                Listen while driving or working with our audio-only option.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </Layout>;
}